module.exports = __webpack_public_path__ + "img/avatar3.f633d986.png";